export const STRIPE_DASHBOARD = 'https://dashboard.stripe.com';
export const BRAINTREE_DASHBOARD = 'https://www.braintreegateway.com/merchants/9ncqgdjrnmy6hssn';
